module.exports = {
        srcSet: __webpack_public_path__ + "c2e5fcd7fcfcb065-600.webp"+" 600w"+","+__webpack_public_path__ + "a7b105e87fe920d2-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "c2e5fcd7fcfcb065-600.webp",width: 600,height: 400},{path: __webpack_public_path__ + "a7b105e87fe920d2-1000.webp",width: 1000,height: 667}],
        src: __webpack_public_path__ + "a7b105e87fe920d2-1000.webp",
        toString: function(){return __webpack_public_path__ + "a7b105e87fe920d2-1000.webp"},
        
        width: 1000,
        height: 667
      }